<template>
  <div>
    <div class="header py-7 py-lg-8 pt-lg-4"></div>
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <img style="width:200px; display:block; margin: 0 auto 2rem auto" :src="logo" class="navbar-brand-img" alt="RapidAIM" />
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <base-alert type="info">
                To reset your password, please provide the email address associated with your account. We will send you a reset code shortly.
              </base-alert>

              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(sendResetCode)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="email"
                    :rules="{ required: true, regex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/ }"
                    prepend-icon="fas fa-user"
                    placeholder="Email"
                    autocomplete="off"
                    v-model="model.email"
                    :messages="{ email: 'Email address is invalid' }"
                  >
                  </base-input>
                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">Send code</base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseAlert from '@/components/BaseAlert';
import api from '@/api';

export default {
  components: {
    BaseAlert
  },
  props: {
    logo: {
      type: String,
      default: 'https://i2.wp.com/rapidaim.io/wp-content/uploads/2019/04/logo-horizontal-reversed-01-2x-contrast.png?fit=395%2C102&ssl=1',
      description: 'RapidAIM'
    },
  },
  data() {
    return {
      autocomplete: 'off',
      error: null,
      model: {
        email: ''
      }
    };
  },
  methods: {
    sendResetCode() {
      const { email } = this.model;
      const loader = this.$loading.show();
      this.error = null;

      const setError = (error) => {
        loader.hide();
        this.error = error;
      }

      const navigateToResetPassword = () => {
        loader.hide();
        this.$router.push({name: "ResetPassword", params: { email, success: true }});
      }

      try {
        api.auth.sendResetCode({ email:email, handleError: setError, handleNavigateToResetPassword: navigateToResetPassword });
      } catch (error) {
        loader.hide();
        this.error = error.message
      }
    }
  }
};
</script>
